import { render, staticRenderFns } from "./CommentsFill.vue?vue&type=template&id=b76afe52&"
import script from "./CommentsFill.vue?vue&type=script&lang=js&"
export * from "./CommentsFill.vue?vue&type=script&lang=js&"
import style0 from "./CommentsFill.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports